import React from 'react';

/**
 * Allows a TableCell to automatically detect when to use a `th` tag
 * See: https://github.com/mui/material-ui/blob/master/packages/mui-material/src/Table/Tablelvl2Context.js
 */
export interface TableCellTagContextProps {
  tag: 'td' | 'th';
}

const TableCellTagContext = React.createContext<
  TableCellTagContextProps | undefined
>(undefined);

export default TableCellTagContext;
